const initialState = {
  listArtist: []
}

const homeListReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'ADD_LIST_HOME':
      return {
        ...state,
        listArtist: state.listArtist.concat(action.payload)
      }
    default:
      return state
  }
}

export default homeListReducer